import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./CategoryLanding.css";
import { useLanguage } from "./LanguageContext";

const categoryData = {
  kultura: {
    title: "Kultura",
    description: "Miejsca, które inspirują, opowiadają historie i zostają z nami na dłużej.",
    items: [
      ["Muzea", "kultura/muzea"],
      ["Teatry", "kultura/teatry"],
      ["Kina", "kultura/kina"],
      ["Zabytki", "kultura/zabytki"],
      ["Inne", "kultura/kulturaInne"],
    ],
  },
  gastronomia: {
    title: "Gastronomia",
    description: "Smaki na szybki lunch, spokojną kawę i wieczór przy dobrym stole.",
    items: [
      ["Restauracje", "gastronomia/restauracje"],
      ["Fast foody", "gastronomia/fastFoody"],
      ["Kawiarnie", "gastronomia/kawiarnie"],
      ["Desery", "gastronomia/desery"],
      ["Inne", "gastronomia/gastronomiaInne"],
    ],
  },
  nauka: {
    title: "Nauka",
    description: "Przestrzenie do nauki, rozwijania ciekawości i szukania nowych pomysłów.",
    items: [
      ["Biblioteki", "nauka/biblioteki"],
      ["Księgarnie", "nauka/ksiegarnie"],
      ["Kursy", "nauka/kursy"],
      ["Targi i kiermasze", "nauka/targi"],
      ["Inne", "nauka/naukaInne"],
    ],
  },
};

function CategoryLanding({ category }) {
  const { t } = useLanguage();
  const currentCategory = categoryData[category];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [category]);

  return (
    <main className="category-landing">
      <div className="category-landing-heading">
        <p className="eyebrow">{t("discoverByCategory")}</p>
        <h1>{t({ kultura: "culture", gastronomia: "food", nauka: "learning" }[category])}</h1>
        <p>{t({ kultura: "cultureDescription", gastronomia: "foodDescription", nauka: "learningDescription" }[category])}</p>
      </div>
      <div className="category-landing-grid">
        {currentCategory.items.map(([label, to]) => (
          <Link className="category-landing-card" to={`/${to}`} key={to}>
            <span>{t({ Muzea: "museums", Teatry: "theatres", Kina: "cinemas", Zabytki: "monuments", Inne: "other", Restauracje: "restaurants", "Fast foody": "fastFood", Kawiarnie: "cafes", Desery: "desserts", Biblioteki: "libraries", Księgarnie: "bookstores", Kursy: "courses", "Targi i kiermasze": "fairs" }[label])}</span>
            <strong aria-hidden="true">&#8594;</strong>
          </Link>
        ))}
      </div>
    </main>
  );
}

export default CategoryLanding;
